export const convertDateAndTimeToLocaleHandler=(date:string)=>{
    if(!date){
        return '';
    }
    const getDate=date.split('T')[0].split('-').reverse().join('.');
    const time= date.split("T")[1].split(":").slice(0, 2).join(":")

    return getDate+" "+"в"+" "+time
}